import React, { Component, useContext } from "react";
import { contexData } from "@/store";

function AnswerValidity({
  children,
  direction,
  info,
  answer,
  changeAnswer,
  style: styles,
  ...other
}) {
  const { infoContex, dispatch } = useContext(contexData); //解构得到属性
   if (direction) {
    return (
      <div
        id={info.id}
        {...other}
        style={{
          background:
            info.id == infoContex.highlight ? " rgb(24, 144, 255)" : "",
          ...styles,
        }}
      ></div>
    );
  }
  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
        if (info.id == infoContex.highlight) {
          dispatch({ type: "highlight", data: { highlight: "" } });
        }
      }}
      style={{
        background: info.id == infoContex.highlight&& info.model!="upload_other" ? " rgb(24, 144, 255)" : "",
        ...styles,
      }}
      {...other}
    >
      {children}
    </div>
  );
}

export default AnswerValidity;
